import ActiveSubscription from "types/ActiveSubscription";
import { DataRouteDefinition } from "routes/data-routes/types";


export const ActiveSubscriptionDataRoutePath = "/data-routes/billing-data/subscription";

export type ActiveSubscriptionDataRouteType = Required<DataRouteDefinition<ActiveSubscription, "activeSubscription", typeof ActiveSubscriptionDataRoutePath>>;
